// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import MainLayout from "./components/MainLayout";
import AdminHome from "./pages/AdminHome";
import WhatsappConfig from "./components/WhatsappConfig";
import Secuencias from "./components/Secuencias";
import Leads from "./components/Leads";
import Automations from "./components/Automations";
import LandingPage from "./components/LandingPage";
import Chat from "./components/Chat";
import FormularioCancion from "./components/formularioCancion";
import WhatsappButton from "./components/whatsappButton";
import Produccion from "./components/Produccion";
import FormularioMusica from "./components/CreacionMusica";
import EscucharCancion from './components/EscucharCancion';

// ProtectedRoute que acepta múltiples roles y espera a que useAuth cargue
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, userRole, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(userRole)) return <Navigate to="/login" replace />;

  return children;
};

const App = () => (
  <Router>
    <Routes>
      {/* Rutas públicas */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registro" element={<RegisterPage />} />
      <Route path="/lead" element={<LandingPage />} />

      {/* Prefill de teléfono desde el path */}
      <Route path="/:phone" element={<FormularioCancion />} />

      {/* Formulario de canción público (query) */}
      <Route path="/formulario-cancion" element={<FormularioCancion />} />
      <Route path="/formulario-musica" element={<FormularioMusica />} />

      {/* Botón público de WhatsApp */}
      <Route
        path="/whatsapp-button"
        element={
          <div style={{ padding: 20, textAlign: "center" }}>
            <WhatsappButton messageText="¡Hola! Ya llené el formulario, envíame mi letra 🎵" />
          </div>
        }
      />

      {/* Rutas de admin y superAdmin */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRoles={["admin", "superAdmin"]}>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminHome />} />
        <Route path="whatsapp" element={<WhatsappConfig />} />
        <Route path="secuencias" element={<Secuencias />} />
        <Route path="leads" element={<Leads />} />
        <Route path="automations" element={<Automations />} />
        <Route path="chat" element={<Chat />} />
        <Route path="produccion" element={<Produccion />} />
      </Route>

      {/* Ruta para cobrador */}
      <Route
        path="/cobrador"
        element={
          <ProtectedRoute allowedRoles={["Cobrador"]}>
            <div>Área de Cobrador</div>
          </ProtectedRoute>
        }
      />

      {/* Rutas públicas adicionales */}
      <Route path="/negocio/:businessId" element={<LandingPage />} />
      <Route path="/recibo" element={<LandingPage />} />
      <Route path="/escuchar/:phone" element={<EscucharCancion />} />


      {/* Redirecciones por defecto */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </Router>
);

export default App;
